import axiosIns from "@/axios";

export default {
  namespaced: true,
  state: () => ({
    all: {}, // { bio_short_code: '...', ... }
    platformOptions: [],
  }),
  actions: {
    // Tüm ayarları çek
    async fetchSettings({ commit }) {
      const res = await axiosIns.get('/settings');
      const settingsObj = {};
      (res.data.data || []).forEach(item => {
        settingsObj[item.setting_key] = item;
      });
      commit('setAll', settingsObj);
    },

    // Tek bir ayarı güncelle
    async updateSetting({ commit, state }, { key, value }) {
      await axiosIns.put('/settings', {
        setting_key: key,
        setting_value: value,
      });
      // Güncellediğimiz ayarı state'e de yazalım
      const updated = { ...state.all };
      commit('setAll', updated);
    },

    async loadPlatforms({ commit }) {
      try {
        const response = await axiosIns.get('/platforms', {
          params: { filter: { status: 1 } }
        })
        commit('setPlatforms', response.data.data)
        return response.data.data;
      } catch (error) {
        console.error('Platformlar yüklenirken hata oluştu:', error)
      }
    }

  },
  mutations: {
    setAll(state, payload) {
      state.all = payload;
    },
    setPlatforms(state, platforms) {
      state.platformOptions = platforms
    }
  },
  getters: {
    // Tek bir ayar
    get: (state) => (key) => state.all[key].setting_value,
    // Tüm ayarlar (gerekirse)
    allSettings: (state) => state.all,
  },
}